import React from 'react';

export const LoadingDots = ({dotStyle: style, ...props}) => <div className="lds-ellipsis" {...props}><div style={style}/><div style={style} /><div style={style}/><div style={style} /></div>;

export default LoadingDots;
